import { createContext } from '@wordpress/element';

export const PrivateBlockContext = createContext( {} );
PrivateBlockContext.displayName = 'PrivateBlockContext';
